<template>
  <div class="wrapper">
    <div class="boxborder" id="boxborder" :style="{transform: scaling}">
      <div id="generatorcontainer">
        <div class="image" style="position: relative">
        <!-- GENERATED CAMPAIGN POSTER ITSELF -->
        <img v-bind:src="imageLink" :style="{backgroundImage: imageLinkBG}"/>
        <ul
          :style="[containerStyle, customContainerVersionStyle]" id="textcontainer" :class="{ rotated : isRotated }">
          <block v-for="line in lines" :real-time="true" :text="line.text" :type="line.style"
                 :fontSize="line.fontSize"></block>
          <br><br>
        </ul>
        </div>
        <div v-if="showDisclaimer" style=" font-weight: 500; width: 100%; text-align: center; color: #999; font-size: 14px; padding: 10px 20px; background-color: #EEE;">Dies Meisterwerk ist kein offizielles Plakat, es wurde mit <strong style="opacity: 0.9; background-image:linear-gradient(-70deg, #3023AE, #C86DD7);
 -webkit-background-clip: text;
 -webkit-text-fill-color: transparent;">plakatgenerator.com</strong> erstellt</div>
      </div>
    </div>
    <div class="builder">
      <div v-for="(line, index) in lines" class="builder-line">
        <input v-model="line.text" name="" value="" class="input"><br>
        <!-- FONT SIZE SELECTION -->
        <div style="padding: 5px 0; margin-top: 5px;">
          <label class="label">GRÖSSE:</label>
          <input type="range" min="0" max="100" v-model="line.fontSize">
          <input type="number" min="0" max="100" v-model="line.fontSize">
        </div>
        <!-- STYLE SELECTION -->
        <div style="padding-bottom: 5px">

        <label class="label">STIL:</label>
        <div class="select is-small">
          <select v-model="line.style">
            <option v-for="(style, index) in styles" v-bind:value="index">
              <div style="width: 10px; height: 10px; background-color: red;">{{ style.name }}</div>
            </option>
          </select>
        </div>
          <button class="button is-small" type="button" name="button" style="float: right" v-on:click="removeLine(index)">
            X
          </button>

        </div>
        <!-- REMOVE LINE -->
      </div>
      <!-- ADD LINE -->
      <button type="button" name="button" class="button" v-on:click="addLine" style="margin-top: 10px;">Box Hinzufügen
      </button>
    </div>
    <div class="disclaimer" style="max-width: 800px">
      <label class="checkbox" >
        <input type="checkbox" v-model="showDisclaimer" style="margin: 5px;">
        <strong>Disclaimer anzeigen?</strong><br>
        <p style="padding-left: 27px; padding-top: 5px;">Aus Gründen sind die diesjährigen Plakate standardmäßig mit einem Disclaimer versehen, dass es sich nicht um ein offizielles Plakat handelt. Situationselastisch kann er mit dieser Checkbox entfernt werden.</p>
      </label>

    </div>
    <div class="download">
      <a name="button" id="downloadbutton" v-bind:class="{ disabled: loadingDownload }" v-on:click="download">DOWNLOAD
        <spinner v-if="loadingDownload" style="top: -3px; margin-left: 10px;"></spinner>
      </a>
      <p v-if="statusText" style="max-width: 500px; margin: 20px auto;">{{ statusText }}</p>
    </div>
  </div>
</template>

<script>
    import Block from '../components/Block.vue';
    import Spinner from "./Spinner";
    import {saveAs} from 'file-saver';
    import domtoimage from 'dom-to-image';
    import html2canvas from 'html2canvas'
    import axios from 'axios'

    export default {
        name: 'Builder',
        components: {
            Block,
            Spinner
        },
        data(){
            return {
                loadingDownload: false,
                statusText: null
            }
        },
        computed: {
            styles() {
                return this.$store.getters.getCustomStyles;
            },
            containerStyle() {
                return this.$store.getters.getContainerStyle;
            },
            customContainerVersionStyle(){
                return this.$store.getters.getCustomContainerVersionStyle;
            },
            imageLink() {
                return require('../assets/' + this.$store.state.currentVersion)
            },
            imageLinkBG() {
                return "url(" + require('../assets/' + this.$store.state.currentVersion) + ")";
            },
            lines: {
                get() {
                    return this.$store.state.lines;
                },
                set(value) {
                    this.$store.state.lines = value;
                }
            },
            showDisclaimer: {
                get(){
                    return this.$store.state.showDisclaimer;
                },
                set(value){
                    this.$store.state.showDisclaimer = value;
                }
            },
            isRotated() {
                return false;
                //return this.$store.getters.isRotated;
            },
            scaling() {


                if (browserWidth < 1150) {
                    return 'scale(' + browserWidth / 900 + ')';
                }

return 'scale(1)';
                /* scaling the generator via CSS Transform so that element sizes stay
                usable in relation to each other */
                if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
                    return 'scale(1)'
                }
                var browserWidth = Math.max(
                    document.body.scrollWidth,
                    document.documentElement.scrollWidth,
                    document.body.offsetWidth,
                    document.documentElement.offsetWidth,
                    document.documentElement.clientWidth
                );
                if (browserWidth < 1150) {
                    return 'scale(' + browserWidth / 900 + ')';
                }
            }
        },
        methods: {
            addLine() {
                this.lines.push({
                    fontSize: '60',
                    text: 'Platzhalter',
                    style: 0
                });
            },
            download(event) {
                if(this.loadingDownload){
                    console.log("Cancel Download");
                    return false;
                }
                let currentState = this.$store.state;
                this.loadingDownload = true;
                this.statusText = 'Ein kleiner Roboter macht das Bild für dich zum Download bereit. Das kann ein paar Sekunden dauern.';

                axios({
                    url: process.env.NODE_ENV === 'production' ? 'https://renderer.plakatgenerator.com' : 'http://renderer.plakatgenerator20.test',
                    method: 'POST',
                    responseType: 'blob', // important,
                    data: currentState
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'download.jpg');
                    document.body.appendChild(link);
                    link.click();
                    this.loadingDownload = false;
                    this.statusText = null;
                })
                    .catch(function (error) {

                        if (error.response.status === 429) {
                            this.statusText = 'Whoops. Du hast ein bisschen zu viele Bilder generiert, warte ein bisschen und versuch es später nochmal, oder mach einfach einen Screenshot';
                        }
                        else{
                            this.statusText = 'Whoops. Irgenwas ist schief gegangen. Sorry, versuchs in ein paar Minuten nochmal, im Zweifel kannst du auch einen Screenshot vom Plakat machen.';
                        }
                    });
            },
            removeLine(index) {
                this.$store.commit('removeParty', index);
            }
        }
    }

    function preRender() {
        /* scrolls to the top of the page and guarantee that the page is in a state so that the
        safari rendering works */
        try {
            window.scrollTo(0, 0);
            document.getElementById("viewport").setAttribute("content",
                'content="width=1150px, initial-scale=0.1, maximum-scale=0.1, user-scalable=no');
        } catch (e) {
            document.write(e);
        }
    }
</script>

<!-- Styling for the generator -->
<style scoped>
  .wrapper {
    position: relative;
    display: inline-block;
    max-width: 100%;
  }

  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
    position: absolute;
  }

  li {
    display: inline-block;
  }

  a {
    color: #42b983;
  }

  img {
    width: 700px;
    max-width: none;
    display: block;
    background-size: contain;
  }

  .rotated {
    transform: rotate(-5deg) translateX(-50px);
  }

  .override {
    transform: scale(1) !important;
  }

  #textcontainer {
    width: 100%;
    text-align: left;
    bottom: 0;
  }

  #generatorcontainer {
    position: relative;
    overflow: hidden;
  }

  .boxborder {
    border: 10px #FFF solid;
    box-shadow: 0px -10px 20px rgba(0, 0, 0, 0.3);
    float: left;
    transform-origin: left top;
    transform: scale(calc(100% / 900));
  }

  /* BUILDER (Sidebar) */

  .builder {
    width: 280px;
    float: left;
    padding-left: 10px;
  }

  .label {
    color: #333;
    margin-bottom: 0;
    margin-top: 3px;
    float: left;
  }

  input[type="range"] {
    width: 90px;
    margin-top: 6px;
  }

  input[type="number"] {
    display: none;
  }

  .builder-line {
    border-bottom: 3px #C86DD7 solid;
    padding: 15px;
    background-color: #FFF;
    margin-bottom: 10px;
    border-radius: 10px;
    box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.1);

  }

  .disclaimer{
    clear: both;
    text-align: left;
    padding-top: 20px;
    text-shadow: 0 0 10px #FFF;
  }

  /* DOWNLOAD BUTTON */

  .download {
    width: 100%;
    display: block;
    clear: both;
    padding-top: 50px;
    margin-bottom: 50px;
  }

  .download a {
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    border: 0;
    padding: 10px 30px;
    font-size: 1.2rem;
    color: #FFF;
    background: linear-gradient(70deg, #3023AE, #C86DD7);
    background-repeat: no-repeat;
    transition: box-shadow 700ms ease, background 700ms ease;
  }

  .download a:hover {
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
    background: linear-gradient(100deg, #3023AE, #C86DD7);
  }

  .download a:hover {
    cursor: pointer;
  }

  .download a.disabled{
    opacity: 0.8;
  }

  .download a.disabled:hover{
    cursor: progress;
  }

  /* RESPONSIVENESS */

  @media (max-width: 1150px) {
    .builder {
      width: 100%;
    }

    input[type="number"] {
      display: inline-block;
    }

    input {
      text-align: center;
    }

    .borderbox {
      transform: scale(calc(100% / 700));
    }

  }

  @media (max-width: 500px) {
    .builder {
      margin-top: -170px;
    }
  }
</style>



// WEBPACK FOOTER //
// Builder.vue?570deff3